/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { useTranslation } from "react-i18next";

import {
  DeleteFilledIcon,
  EditIcon,
  FileDownloadProgressIcon,
  SendIcon
} from "@dotnet/telematics-design-system";

import {
  COMPANIES_ACTIONS,
  ICON_DEFAULT_STYLE,
  NEWS_ACTIONS,
  VEHICLES_ACTIONS
} from "../../..";
import ListChoice from "../../../../components/ListChoice/ListChoice";

interface MoreMenuChoiceProps {
  action: NEWS_ACTIONS | COMPANIES_ACTIONS | VEHICLES_ACTIONS;
  onButtonClick: () => void;
  testId?: string;
  dialog?: React.ReactNode;
}

const MoreMenuChoice = ({
  action,
  onButtonClick,
  testId,
  dialog
}: MoreMenuChoiceProps) => {
  const { t } = useTranslation();

  const iconCustomStyle = {
    ...ICON_DEFAULT_STYLE,
    alignSelf: "center"
  };

  const renderTitle = () => {
    switch (action) {
      case NEWS_ACTIONS.EditNews:
        return t("News##edit");
      case NEWS_ACTIONS.Publish:
        return t("News##publish");
      case NEWS_ACTIONS.Delete:
        return t("News##delete");
      case COMPANIES_ACTIONS.EditCompanyCard:
        return t("Details##edit");
      case VEHICLES_ACTIONS.DownloadStatus:
        return t("Details##download status");
      default:
        return "";
    }
  };

  const renderIcon = () => {
    switch (action) {
      case NEWS_ACTIONS.EditNews:
      case COMPANIES_ACTIONS.EditCompanyCard:
        return <EditIcon css={css(iconCustomStyle)} />;
      case NEWS_ACTIONS.Publish:
        return <SendIcon css={css(iconCustomStyle)} />;
      case NEWS_ACTIONS.Delete:
        return <DeleteFilledIcon css={css(iconCustomStyle)} />;
      case VEHICLES_ACTIONS.DownloadStatus:
        return <FileDownloadProgressIcon />;
      default:
        return <></>;
    }
  };

  return (
    <>
      <ListChoice
        data-testid={testId ?? "more-menu-choice"}
        title={renderTitle()}
        iconLeft={renderIcon()}
        onClick={onButtonClick}
        alignIconCenter
      />
      {dialog}
    </>
  );
};

export default MoreMenuChoice;
